'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.assertNullable = void 0;
function assertNullable(val) {
    if (val === undefined || val === null) {
        throw new Error('value is expected to be defined');
    }
}
exports.assertNullable = assertNullable;
